import React from 'react';
import { CheckCircle, Target, Users, Award } from 'lucide-react';

const About = () => {
  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '500+', label: 'Projects Completed' },
    { number: '200+', label: 'Happy Clients' },
    { number: '50+', label: 'Team Members' }
  ];

  const values = [
    {
      icon: Target,
      title: 'Excellence',
      description: 'We strive for excellence in every project, delivering solutions that exceed expectations.'
    },
    {
      icon: Users,
      title: 'Collaboration',
      description: 'We believe in working closely with our clients to understand and fulfill their unique needs.'
    },
    {
      icon: Award,
      title: 'Innovation',
      description: 'We embrace cutting-edge technologies and innovative approaches to solve complex problems.'
    },
    {
      icon: CheckCircle,
      title: 'Integrity',
      description: 'We maintain the highest standards of integrity and transparency in all our business dealings.'
    }
  ];

  return (
    <div className="page-container">
      {/* About Hero */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="page-title">About StoryBox Solutions</h1>
          <p className="about-hero-text">
            Founded with a vision to transform businesses through technology, StoryBox Solutions has grown 
            into a leading IT services provider. We specialize in delivering comprehensive software development, 
            mobile application development, quality assurance, and data management solutions.
          </p>
        </div>
        <div className="about-hero-image">
          <img 
            src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw1fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85"
            alt="Office environment"
            className="about-img"
          />
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <h3 className="stat-number">{stat.number}</h3>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Company Story */}
      <section className="story-section">
        <h2 className="section-title">Our Story</h2>
        <div className="story-content">
          <p className="story-text">
            StoryBox Solutions was established in 2013 with a clear mission: to bridge the gap between 
            business challenges and technology solutions. What started as a small team of passionate developers 
            has now evolved into a comprehensive IT services company serving clients across the globe.
          </p>
          <p className="story-text">
            Over the years, we have successfully delivered 500+ projects across various industries including 
            finance, healthcare, retail, and manufacturing. Our commitment to quality, timely delivery, and 
            customer satisfaction has earned us the trust of leading organizations worldwide.
          </p>
          <p className="story-text">
            Today, we continue to push boundaries, embrace emerging technologies, and help our clients stay 
            ahead in an increasingly digital world.
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <h2 className="section-title">Our Core Values</h2>
        <div className="values-grid">
          {values.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default About;
